import { VdsBasicInput } from '@volt/volt-extended-components-react';
import { ReactElement, Ref, useCallback } from 'react';
import { VdsBasicInputCustomEvent } from '@volt/volt-basic-components';
import Field, { FieldProps } from '@cas/components/inputs/field/Field';

interface NumberInputProps extends FieldProps {
  elementRef?: Ref<HTMLVdsBasicInputElement>;
  value: number | null;
  placeholder?: string;
  onChange: (value: number | null) => void;
}

export function NumberInput({
  uid,
  elementRef,
  value,
  label,
  tooltipLabel,
  placeholder = '',
  onChange,
}: NumberInputProps): ReactElement {
  const stringValue = typeof value === 'number' ? value.toString() : '';

  // Only submit valid values to the store. Exclude non-numbers, truncate floats, and convert empty strings to null.
  const onChangeInput = useCallback(
    (event: VdsBasicInputCustomEvent<string>) => {
      const intVal = parseInt(event.detail);
      if (!isNaN(intVal)) {
        onChange(intVal);
      } else if (event.detail === '') {
        onChange(null);
      } else {
        // This console warning is not essential, but it's purpose is to make sure the underlying VDS component is behaving as expected.
        console.warn(
          `NumberInput id='${uid}' emitted an unexpected onChange event value that was not handled: ${event.detail}`,
        );
      }
    },
    [uid, onChange],
  );

  return (
    <Field uid={uid} label={label} tooltipLabel={tooltipLabel}>
      <VdsBasicInput
        ref={elementRef}
        id={uid}
        placeholder={placeholder}
        onChangeInput={onChangeInput}
        value={stringValue}
        type="number"
        size="medium"
      />
    </Field>
  );
}

export default NumberInput;
